/* eslint-disable */
import React, { useState } from "react";
import styles from "./kanbanBoardLeadRegister.module.scss";
import { LuRefreshCcw } from "react-icons/lu";
import { PiFunnelBold } from "react-icons/pi";
import Pagination from "@mui/material/Pagination";
import PipelineCard from "./PipelineCard";
import { FaPlus } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import CandidateLead from "../../pages/Candidate/CandidateLeadTable/CandidateLeadPostForm";
import { MyModal } from "../Common/Model/MyModal";
import ModalContainer from "../Common/Model/ModalContainer";

const KanbanColumn = ({
  title,
  color,
  bgLight,
  data,
  total,
  loading,
  page,
  totalPages,
  onRefresh,
  onRegRefresh,
  onPageChange,
  isRefreshing,
  activeTab,
  onSelectCandidate,
  onSelectLeadCandidate,
  // ── NEW: individual filter props ──
  hasFilter, // boolean — lights up filter icon
  onFilterOpen, // () => void — opens the column-specific offcanvas
}) => {
  const [leadGeneration, setLeadGeneration] = React.useState(false);
   const [hover, setHover] = useState(false);
    const [showCheckButton, setShowCheckButton] = useState(false);
  return (
    <div className={styles.column}>
      {/* HEADER */}
      <div className={styles.columnHeader}>
        <span className={styles.title}>
          {title}
          <span className={styles.badge} style={{ background: bgLight, color }}>
            {total}
          </span>
          
        </span>

        <div className={styles.headerActions}>
          {/* Individual column filter button */}
          {activeTab === "leads" && (
            <span
              onClick={() => {
                setLeadGeneration(true);
              }}
            >
              {" "}
              <FaPlus className={styles.faplus} />
            </span>
          )}
          <div>
            <LuRefreshCcw
              className={`${styles.refresh} ${isRefreshing ? styles.spin : ""}`}
              style={{ color }}
              onClick={onRefresh}
            />
          </div>
          {onFilterOpen && (
            <button
              className={`${styles.colFilterBtn} ${hasFilter ? styles.colFilterActive : ""}`}
              onClick={onFilterOpen}
              title={`Filter ${title}`}
            >
              <PiFunnelBold size={14} />
              {hasFilter && <span className={styles.filterDot} />}
            </button>
          )}
        </div>
      </div>

      {/* BODY */}
      <div className={styles.body}>
        {data?.length
          ? data.map((c) => (
              <PipelineCard
                key={c.id}
                data={c}
                activeTab={activeTab}
                onSelectCandidate={onSelectCandidate}
                onSelectLeadCandidate={onSelectLeadCandidate}
                onRefresh={onRefresh}
                onRegRefresh={onRegRefresh}
              />
            ))
          : !loading && (
              <div className={styles.empty}>
                <p>No Data Found</p>
              </div>
            )}
      </div>

      {/* PAGINATION */}
      <div className={styles.pagination}>
        <Pagination
          count={totalPages || 1}
          page={page}
          onChange={onPageChange}
          size="small"
          sx={{
            "& .MuiPaginationItem-root": { color },
            "& .Mui-selected": {
              backgroundColor: `${color} !important`,
              color: "#fff",
            },
          }}
        />
      </div>
      {leadGeneration && (
        <MyModal>
          <ModalContainer>
            <>
             <div className="p-2" style={{ width: "800px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fs-4">
                      <b>Candidate Lead Generation</b>
                    </div>
                    <div className="d-flex align-items-center">
                      {/* {showCheckButton && (
                        <button
                          type="button"
                          className="btn btn-outline-primary me-2"
                          style={{
                            padding: "5px 15px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            border: "1px solid #169c50",
                            backgroundColor: hover ? "#169c50" : "transparent",
                            color: hover ? "white" : "#169c50",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setHover(true)}
                          onMouseLeave={() => setHover(false)}
                          onClick={() => {
                            // Get mobile number - you'll need to pass this from CandidateLead
                            // For now, we'll handle this later
                            console.log("Check here clicked");
                            setShowMobileFilter(true);
                          }}
                        >
                          Check here
                        </button>
                      )} */}
                      <div
                        className="btn btn-outline-danger"
                        onClick={() => {
                          setLeadGeneration(false);
                        }}
                      >
                        <AiOutlineClose />
                      </div>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{ height: "65vh", overflow: "auto" }}
                  >
                    <CandidateLead
                      oncloseLead={() =>
                        setLeadGeneration(false)
                      }
                      Reloadresponse={onRefresh}
                      onShowCheckButton={setShowCheckButton}
                      // onNumberExists={setExistingMobileNumber}
                    />
                  </div>
                </div></>
          </ModalContainer>
        </MyModal>
      )}
    </div>
  );
};

export default KanbanColumn;
